const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
const Popup = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domBody: $('body'),
	$domProductPopupPopup: $('.js-product-popup'),
	$domProductPopupInner: $('.js-product-popup__inner'),
	$domProductCloseIcon: $('.js-product-popup-ico'),
	$domProductPopBtn: $('.js-product-block__product'),
	classActive: 'is-active',
	classPreventScroll: 'prevent-scroll',
	classHasTransition: 'has-transition',

	/** @description Initialize */
	init: function() {
		this.productPopupShow();
		this.productPopupHide();
		this.closeMenuOnOusideContainerClickProduct();
		Global.escKey(Popup.closeProductPopup);
	},

	productPopupShow: function() {
		$('.js-product-block__product').each(function(i, el) {
			$(el).on('click', function() {
				const popupNum = $(el).data('product');
				$('body').addClass(Popup.classPreventScroll);
				$(`.js-product-popup-${popupNum}`).addClass(Popup.classActive);
				$(`.js-product-popup-${popupNum}`).addClass(Popup.classHasTransition);
			});
		});
	},

	productPopupHide: function() {
		$('.js-product-popup-ico').each(function(i, el) {
			$(el).on('click', function() {
				Popup.closeProductPopup();
			});
		});
	},

	closeProductPopup: function() {
		$('body').removeClass(Popup.classPreventScroll);
		$('.js-product-popup').removeClass(Popup.classActive);
	},

	/* @description close menu if click outside container */
	closeMenuOnOusideContainerClickProduct: function() {
		$('body').on('mouseup', function(e) {
			e.preventDefault();
			if ($('.js-product-popup').hasClass(Popup.classActive) && !$('.js-product-popup__inner').is(e.target) && $('.js-product-popup__inner').has(e.target).length === 0 && !$('.js-product-popup-ico').is(e.target)) {
				Popup.closeProductPopup();
			}
		});
	},
};

export default Popup;